import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Fetches the daily reports from the backend.
 *
 * Sends a GET request to the `/reports/daily` endpoint using the centralized API utility.
 * Assumes authentication is handled within the `apiCall` utility (i.e., token is attached there).
 *
 * @returns {Promise<Object>} - The response data containing the daily reports.
 *
 * @throws {Error} - Throws an error if the request fails or the server returns an error.
 * 
 * @author Susovan
 */
const fetchDailyReport = async () => {
  return await apiCall(AUTH_ROUTES.DAILY_REPORT_API_ENDPOINT, {
    method: "GET",
  });
};

export default fetchDailyReport;
